import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BaseReadOnlyService } from '../../services/base-readonly.service';
import { ClinicalRecordType } from './clinical-record-type.model';

@Injectable({
    providedIn: 'root'
})
export class ClinicalRecordTypeService extends BaseReadOnlyService<ClinicalRecordType> {

    constructor(protected http: HttpClient) {
        super(http, 'clinicalrecordtype');
    }
}
